import { EventSinglePage, GalleryImage } from "@/types";
import React, { useState } from "react";

import Info from "./components/Info";

import blue from "@/assets/blue.svg";
import breadcrump from "@/assets/breadcrump.svg";
import gallery_colored from "@/assets/gallery-colored.svg";
import gallery_icon from "@/assets/gallery.svg";
import info_colored from "@/assets/info-colored.svg";
import info from "@/assets/info.svg";
import map_colored from "@/assets/map-colored.svg";
import map from "@/assets/map.svg";
import phone from "@/assets/phone.svg";

import Star from "@/components/Star";
import AppLayout from "@/layouts/AppLayout";
import SEO from "@/utils/SEO";
import TransLink from "@/utils/TransLink";
import { router, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import StyledSinglePage, { SinglePageOverlay } from "../Styles/StyledSinglePage";
import Gallery from "./components/Gallery";
// import Map from "./components/Map";
import Map from "@/components/Map"
import useGeolocation from "@/hooks/useGeolocation";
import { CATEGORY_COLORS } from "@/utils/constants";
import Share from "@/features/share/Share";

type GalleryItem = {
    image: string;
};

const Show: React.FC<EventSinglePage> = ({ event }) => {
    useGeolocation();
    const { data } = event;
    const { seo } = usePage().props;
    const [activeTab, setActiveTab] = useState<number>(0);
    const [gallery, setGallery] = useState<GalleryImage[]>();
    const [loading, setLoading] = useState<boolean>(false);
    const { t } = useTranslation(["common", "validation", "glossary"]);


    const tabs = [
        {
            id: 0,
            title: t("info", { ns: "glossary" }),
            content: <Info event={event} />,
            icon: info,
            iconColored: info_colored,
        },
        {
            id: 1,
            title: "Gallery",
            content: <Gallery loading={loading} gallery={gallery} />,
            icon: gallery_icon,
            iconColored: gallery_colored,
        },
        {
            id: 2,
            title: t("map", { ns: "glossary" }),
            content: (
                <Map
                    coords={{
                        lng: data.lng,
                        lat: data.lat,
                    }}
                    color={CATEGORY_COLORS.Events}
                />
            ),
            icon: map,
            iconColored: map_colored,
        },
    ];

    const onTabChange = (id: number) => {
        if (id === 1 && typeof gallery == "undefined") {
            router.reload({
                only: ["images"],
                onStart: () => {
                    setLoading(true);
                },
                onSuccess: (page) => {
                    if (page.props.images.length != 0) {
                        setGallery(page.props.images);
                    } else {
                        setGallery(null);
                    }
                },
                onFinish: () => {
                    setLoading(false);
                },
            });
        }
        setActiveTab(id);
    };


    return (
        <AppLayout>
            <StyledSinglePage image={data.banner_image}>
                <SEO seo={seo} />
                <div className="bg-image h-[600px] bg-cover bg-center w-full flex justify-center items-center lg:items-end relative pb-20 ">
                    <SinglePageOverlay />

                    <div className="text-white container z-10 flex flex-row items-center justify-between flex-wrap px-2 gap-4 ">
                        <div>
                            <div className="text-3xl font-bold mb-4">
                                {data.name}
                            </div>
                            <div className="flex flex-row items-center gap-4">
                                <img src={blue} />
                                <div className="text-base flex flex-row items-center gap-4">
                                    <TransLink
                                        url={
                                            "/search?isMapView=true&page=1&searchScope[0]=Event"
                                        }
                                    >
                                        {t("Event", { ns: "glossary" })}
                                    </TransLink>
                                    <img src={breadcrump} />{" "}
                                    <TransLink
                                        url={
                                            "/search?isMapView=true&page=1&searchScope[0]=Event&event_types[0]=" +
                                            data.types?.slug.key
                                        }
                                    >
                                        {data.types?.name}
                                    </TransLink>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row gap-4 h-9 flex-wrap">
                            {data?.ticket_url && (
                                <a
                                    target={'_blank'}
                                    href={data.ticket_url}
                                    className="border-2 pl-6 rounded-3xl flex items-center justify-center gap-6 hover:bg-white hover:text-black transition"
                                >
                                    <div className="text-lg uppercase">
                                        {t("tickets", { ns: "glossary" })}
                                    </div>
                                    <div
                                        className="bg-white h-9 w-9 rounded-3xl flex items-center justify-center left-0.5 lg:left-1 relative">
                                        <svg
                                            className="w-6 h-6 text-gray-800 dark:text-white"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="m9 5 7 7-7 7"
                                            />
                                        </svg>
                                    </div>
                                </a>
                            )}
                            <Share shareUrl={data.url || window.location.href} title={data.name || 'Visit Thassos'} />
                            <Star item={data} />
                            {data.mobile || data.telephone ? (
                                <a
                                    href={`tel:${data.mobile || data.telephone}`}
                                    className="border-2 py-1 px-3 rounded-md flex items-center justify-center gap-6 hover:bg-black/30 transition"
                                >
                                    <img src={phone} className="w-6" />
                                    <div className="text-lg">{t("contact", { ns: "glossary" })}</div>
                                </a>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className="container m-auto flex flex-col pb-20 px-4">
                    <div
                        className="text-center flex flex-wrap md:mt-0 mt-8  md:border md:border-primary justify-between md:justify-start  rounded-lg  self-center w-full md:w-auto md:bg-white bottom-6 relative space-x-2 lg:space-x-0.5 mb-5">
                        {tabs.map((tab) => (
                            <button
                                title={tab.title}
                                key={tab.id}
                                onClick={() => onTabChange(tab.id)}
                                className={`${activeTab === tab.id ? "bg-primary" : "  hover:bg-primary/20"} transition-all p-2 lg:p-3 lg:w-52 rounded-md `}
                            >
                                <div
                                    className={`${activeTab === tab.id ? "text-white" : "text-black"} transition-all flex flex-row items-center justify-center gap-1 lg:gap-4 `}
                                >
                                    <img
                                        src={
                                            activeTab === tab.id
                                                ? tab.icon
                                                : tab.iconColored
                                        }
                                        className="hidden md:inline-block"
                                    />
                                    {tab.title}
                                </div>
                            </button>
                        ))}
                    </div>

                    <div className="md:px-2">{tabs[activeTab].content}</div>
                </div>
            </StyledSinglePage>
        </AppLayout>
    );
};

export default Show;
